module.exports = __webpack_public_path__ + "static/media/rolex.5857e22b.jpg";